import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-donner',
  templateUrl: './donner.component.html',
  styleUrls: ['./donner.component.css']
})
export class DonnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
